import React, { createContext, useState, useEffect } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import Status from "./components/Dashboard/Status";
import Home from "./components/Home/Home";
import "./css/style-old.css";
import "./css/style.css";

// interface context {
  
//     status: string,
//     message: string,
//   setStatus: () => void
// }
function getGroupID(urlParameters: URLSearchParams){
  const groupID = urlParameters.get('groupID')
  if(groupID)
    return parseInt(groupID)
}
function startYear(urlParameters: URLSearchParams): number | 0 {
  const startyear = urlParameters.get('startyear')
  if(startyear)
    return parseInt(startyear)
  return 0
}
function startMonth(urlParameters: URLSearchParams){
  const startmonth = urlParameters.get('startmonth')
  if(startmonth)
    return parseInt(startmonth)
  return 1
}
function startDay(urlParameters: URLSearchParams){
  const startday = urlParameters.get('startday')
  if(startday)
    return parseInt(startday)
  return 1
}

export const UserContext = createContext<any[]>([]);
function App() {
  const [status, setStatus] = useState();
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  const [groupID, setGroupID] = useState<number | undefined | null>(getGroupID(urlParams))
  const startyear = startYear(urlParams);
  const startmonth = startMonth(urlParams);
  const startday = startDay(urlParams);

//  console.log("DEBUG");
//  console.log(startyear);

  useEffect(() => {
      document.title = "Hydromast UI"
  })
 
  return (
    <UserContext.Provider value={[status, setStatus]}>
      <Routes data-testid="router">
        <Route path="/" element={<Home groupID={groupID} startyear={startyear} startmonth={startmonth} startday={startday} />} />
        <Route index element={<Home groupID={groupID} startyear={startyear} startmonth={startmonth} startday={startday} />} />
        <Route path="/status" element={<Status />} />
      </Routes>
    </UserContext.Provider >
  );
}

export default App;
